export default __webpack_public_path__ + "media/images/banner-logo-27b91410c52fb3f21bb3f3ee76391e1c.png";